export const DEVICE_CODE = {
  CONCOX: {
    JC400_W: 1003,
    JC400_D: 1006,
    LL303: 1008,
    JC261: 1009,
    JC400_C: 1010,
  },
  BSJ: {
    GH03T: 6001,
    EH13: 6002,
    MDVR: 6003,
    MDVR08: 6004,
  },
  FLESPI_HOWEN: {
    ME3204: 11009,
    ME3108: 11006,
  },
  VSS_HOWEN: {
    ME4002: 12001,
  },
}

export const JC_CODE = Object.values(DEVICE_CODE.CONCOX)
export const BSJ_CODE = Object.values(DEVICE_CODE.BSJ)
export const FLESPI_HOWEN_CODE = Object.values(DEVICE_CODE.FLESPI_HOWEN)
export const VSS_HOWEN_CODE = Object.values(DEVICE_CODE.VSS_HOWEN)

export const DEVICE_CODE_LIST = {
  CONCOX: [
    DEVICE_CODE.CONCOX.JC400_W,
    DEVICE_CODE.CONCOX.JC400_D,
    DEVICE_CODE.CONCOX.JC400_C,
    DEVICE_CODE.CONCOX.JC261,
  ],
  BSJ: [DEVICE_CODE.BSJ.GH03T, DEVICE_CODE.BSJ.EH13, DEVICE_CODE.BSJ.MDVR, DEVICE_CODE.BSJ.MDVR08],
  BSJ_4_CHANNELS: [DEVICE_CODE.BSJ.GH03T, DEVICE_CODE.BSJ.EH13],
  BSJ_8_CHANNELS: [DEVICE_CODE.BSJ.MDVR, DEVICE_CODE.BSJ.MDVR08],
}
